import { FormikProps } from "formik";
import AppButton from "@/features/line-sheet-sets/app-button";
import { useLocation } from "react-router-dom";
import useRouterHelper from "@/features/ui/hooks/use-router-helper";
import { useMemo } from "react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface AppSubmitButtonProps {
  formik: FormikProps<any>;
  addOther?: boolean;
}
export default function AppSubmitButton({
  formik,
  addOther = false,
}: AppSubmitButtonProps) {
  const location = useLocation();
  const { navigate } = useRouterHelper();
  const { tSentence } = useI18nHelper();

  const defaultPage = useMemo(() => {
    if (/(ko|it|en)?\/line-sheet-sets.*/.test(location.pathname)) {
      return "/line-sheets";
    } else if (location.pathname.includes("edit")) {
      return location.pathname.substring(
        0,
        location.pathname.indexOf("edit") - 1
      );
    } else if (location.pathname.includes("upload")) {
      return location.pathname.substring(
        0,
        location.pathname.indexOf("upload") - 1
      );
    } else {
      return "/";
    }
  }, [location.pathname]);

  // 필드 형식 오류(예: 잘못된 날짜)가 있으면 제출을 막는다.
  const hasInvalidInput = Boolean(
    (formik.status as { hasInvalidInput?: boolean } | undefined)
      ?.hasInvalidInput
  );

  return (
    <AppButton
      variant={addOther ? "normal" : "primary"}
      isDisabled={hasInvalidInput}
      onClick={async () => {
        const result = await formik.submitForm();
        // @ts-ignore
        if (result) {
          if (addOther) {
            formik.resetForm();
          } else {
            navigate(-1, {
              defaultPage,
            });
          }
        }
      }}
      isLoading={formik.isSubmitting}
    >
      {tSentence(addOther ? "common:upload_and_add_another.do" : "upload")}
    </AppButton>
  );
}
